export { CouponCard } from './coupon-card';
export type { CouponCardProps, CouponCardVariant } from './coupon-card.types';
